import { Loader } from 'components'
import React, { useEffect } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

import { GrantTypes } from 'services/auth'
import { ReactComponent as Alert } from '../../assets/svg/alert.svg'
import { usePostAuth } from 'shared/hooks/services/auth'

import styles from './styles.module.scss'
import { useTheme } from 'shared/hooks'

const AppAuthentication: React.FunctionComponent = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { clientId, userId } = useParams()
  const { mutate, isLoading, credentials, error } = usePostAuth()
  const { setTheme } = useTheme()

  useEffect(() => {
    mutate({
      grantType: GrantTypes.UbisafeCode,
      realm: 'ORSEGUPS',
      clientId,
    })
  }, [mutate, clientId])

  useEffect(() => {
    if (credentials) {
      navigate(`/payment-method/${String(userId)}`)
    }

    const theme = searchParams.get('theme') || ''

    if (['dark', 'light'].includes(theme)) {
      setTheme(theme)
    }
  }, [credentials, navigate, userId, searchParams])

  return (
    <div className={styles.container}>
      <>
        {isLoading && <Loader appearance="screen" />}
        {error && (
          <div className={styles.errorWrapper}>
            <Alert />
            <h2 className={styles.unauthorizedTitle}>Acesso não autorizado</h2>
            <p className={styles.unauthorizedInfo}>
              Retorne ao aplicativo e tente novamente
            </p>
          </div>
        )}
      </>
    </div>
  )
}

export default AppAuthentication
